module.exports = __webpack_public_path__ + "img/224-portugal.c083066e.svg";